
import Card from '../../../components/base/Card';

export default function ProductsSection() {
  const categories = [
    {
      id: 1,
      name: 'Whisky Premium',
      description: 'Selección exclusiva de whiskys nacionales e importados',
      image: 'https://public.readdy.ai/ai/img_res/3f09659b65ec7bec5608ed62edb8eb6c.jpg',
      products: ['Buchanan\'s 12 años litro', 'Black & White litro', 'William Grant\'s botella', 'Something Special', 'Black Jack', 'Johnnie Walker', 'Old Parr']
    },
    {
      id: 2,
      name: 'Aguardientes Tradicionales',
      description: 'Aguardientes colombianos auténticos en diferentes presentaciones',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Colombian%20aguardiente%20bottles%20with%20colorful%20labels%20yellow%20blue%20green%20red%20arranged%20on%20rustic%20wooden%20table%20with%20Colombian%20flag%20colors%20warm%20lighting%20authentic%20presentation&width=400&height=300&seq=aguardiente-cat&orientation=landscape',
      products: [
        'Amarillo Manzanares 750ml',
        'Amarillo Manzanares 375ml', 
        'Antioqueño Azul 750ml',
        'Antioqueño Azul 375ml',
        'Nectar Verde 750ml',
        'Nectar Verde 375ml',
        'Antioqueño Verde 750ml',
        'Antioqueño Verde 375ml',
        'Antioqueño Rojo 750ml',
        'Antioqueño Rojo 375ml',
        'Nectar Rojo 750ml',
        'Nectar Rojo 375ml'
      ]
    },
    {
      id: 3,
      name: 'Bebidas Sin Alcohol',
      description: 'Refrescos, aguas y bebidas para toda la familia',
      image: 'https://readdy.ai/api/search-image?query=Non%20alcoholic%20beverages%20collection%20with%20water%20bottles%20and%20soft%20drinks%20arranged%20on%20clean%20white%20background%20with%20fresh%20ice%20cubes%20and%20water%20droplets%20refreshing%20presentation&width=400&height=300&seq=nonalcohol-cat&orientation=landscape',
      products: ['Agua Cristal', 'Coca Cola 500ml']
    },
    {
      id: 4,
      name: 'Confitería',
      description: 'Dulces, chicles y snacks para acompañar',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20candy%20and%20snacks%20collection%20with%20chocolates%20gum%20and%20treats%20arranged%20on%20bright%20background%20with%20vibrant%20packaging%20fun%20presentation&width=400&height=300&seq=candy-cat&orientation=landscape',
      products: ['Bon Bon Bum', 'Chicle Xtime', 'Paquete Detodito BBQ', 'Paquete Detodito Natural', 'Trululu']
    },
    {
      id: 5,
      name: 'Cervezas',
      description: 'Cervezas nacionales, importadas y artesanales',
      image: 'https://readdy.ai/api/search-image?query=Colombian%20beer%20bottles%20and%20cans%20collection%20with%20Poker%20and%20Aguila%20beer%20brands%20arranged%20on%20wooden%20surface%20with%20golden%20lighting%20traditional%20presentation&width=400&height=300&seq=beer-cat&orientation=landscape',
      products: ['Poker', 'Aguila']
    }
  ];

  return (
    <section id="productos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Nuestros Productos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre nuestra amplia selección de licores premium, aguardientes tradicionales, cervezas, 
            bebidas sin alcohol y confitería. Todos nuestros productos son originales y de la más alta calidad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {categories.map((category) => (
            <Card key={category.id} hover className="overflow-hidden">
              <div className="relative h-48">
                <img 
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">{category.name}</h3>
                <p className="text-gray-600 mb-4">{category.description}</p>
                <div className="mb-4">
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">
                    Productos disponibles:
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {category.products.map((product, index) => (
                      <span 
                        key={index}
                        className={`text-xs px-2 py-1 rounded-full ${
                          category.id === 2 
                            ? 'bg-yellow-100 text-yellow-800'
                            : category.id === 3
                            ? 'bg-blue-100 text-blue-800'
                            : category.id === 4
                            ? 'bg-pink-100 text-pink-800'
                            : category.id === 5
                            ? 'bg-orange-100 text-orange-800'
                            : 'bg-red-100 text-red-800'
                        }`}
                      >
                        {product}
                      </span>
                    ))}
                  </div>
                </div>
                <button className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 inline-flex">
                    <i className="ri-shopping-cart-fill"></i>
                  </div>
                  Ver Productos
                </button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">¿No encuentras lo que buscas?</p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2 inline-flex">
              <i className="ri-customer-service-2-fill"></i>
            </div>
            Consultar Disponibilidad
          </button>
        </div>
      </div>
    </section>
  );
}
